import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'
import moment from 'moment'

export class ProgramService {
  async getAllPrograms(accountId, params = {}) {
    try {
      const { page, size, isActive, status, sortBy, sortOrder } = params
      let url = Urls.getApiUrl(
        `admin/${accountId}/programs/all/view`,
        MICROSERVICES.PROGRAMMANAGER,
      )
      url = `${url}?page_no=${page ? page : 0}&page_size=${size ? size : ''}${sortBy ? `&sort_by=${sortBy}` : ''}${sortOrder ? `&sort_order=${sortOrder}` : ''}`
      url = isActive ? `${url}&is_active=true` : url
      url = status ? `${url}&status=${status}` : url
      const response = await service.get(url)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllAvailablePrograms(accountId) {
    try {
      const response = await service.get(Urls.getApiUrl(
        `admin/${accountId}/programs/all`,
        MICROSERVICES.PROGRAMMANAGER,
      ))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getProgramsById(accountId, programId = {}) {
    try {
      let url = Urls.getApiUrl(
        `admin/${accountId}/programs/${programId}`,
        MICROSERVICES.PROGRAMMANAGER,
      )
      const response = await service.get(url)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async createProgram(accountId, param) {
    try {
      const response = await service.post(
        Urls.getApiUrl(
          `admin/${accountId}/programs/basic/add`,
          MICROSERVICES.PROGRAMMANAGER,
        ),
        param,
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async updateProgram(accountId, programId, param) {
    try {
      const response = await service.put(
        Urls.getApiUrl(
          `admin/${accountId}/programs/${programId}`,
          MICROSERVICES.PROGRAMMANAGER,
        ),
        param,
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  //server endpoint api execution function to post user sign in details for response from server
  async postProgramFilesRequest({
    program_enrollment_form_metadata_id,
    file,
    program_file_key,
    accountId,
  }) {
    try {
      var data = new FormData()
      data.append('file', file)
      data.append('program_file_key', program_file_key)
      const config = {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
      const response = await service
        .post(
          Urls.getApiUrl(
            `admin/${accountId}/programenrollmentforms/${program_enrollment_form_metadata_id}/programfile/upload`,
            MICROSERVICES.PROGRAMMANAGER,
          ),
          data,
          config,
        )
      return response
    } catch (e) {
      throw e
    }
  }

  //server endpoint api execution function to get all systems as response from server - PUT method
  async getProgramMetadataOfCurrentProgramAPICall(
    programEnrollmentMetadataId,
    accountId,
  ) {
    let url = Urls.getApiUrl(
      `admin/${accountId}/programenrollmentforms/${programEnrollmentMetadataId}`,
      MICROSERVICES.PROGRAMMANAGER,
    )
    return await service
      .get(url)
      .then((data) => data)
      .catch((error) => error)
  }

  //server endpoint api execution function to get all systems as response from server - PUT method
  async deleteProgramFileAPICall({
    programEnrollmentMetadataId,
    program_file_key,
    accountId,
  }) {
    let url = Urls.getApiUrl(
      `admin/${accountId}/programenrollmentforms/${programEnrollmentMetadataId}/programfile/delete`,
      MICROSERVICES.PROGRAMMANAGER,
    )
    url += '?program_file_key=' + program_file_key
    return await service
      .delete(url)
      .then((data) => data)
      .catch((error) => error)
  }

  //server endpoint api execution function to get all systems as response from server - PUT method
  async downloadProgramFileAPICall({
    programEnrollmentMetadataId,
    program_file_key,
    accountId,
  }) {
    let url = Urls.getApiUrl(
      `admin/${accountId}/programenrollmentforms/${programEnrollmentMetadataId}/programfile/download`,
      MICROSERVICES.PROGRAMMANAGER,
    )
    url += '?program_file_key=' + program_file_key
    return await service
      .get(url)
      .then((data) => data)
      .catch((error) => error)
  }

  async approveProgramRequest(params = {}, accountId) {
    try {
      const { programId } = params
      let url = Urls.getApiUrl(`admin/${accountId}/programs/${programId}/status/update`,
        MICROSERVICES.PROGRAMMANAGER,
      )
      const response = await service.put(url, params)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getBatteryChargeGraphData(accountId, programId, start_date, end_date) {
    let params = { start_date, end_date }
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/program/${programId}/energy_graph`,
        MICROSERVICES.TELEMETRYMANAGER,
      ), { params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getSystemsPending(accountId, programId, page_no, page_size, filter_status) {
    const params = { page_no, page_size, ...(filter_status ? { filter_status: filter_status } : []) }
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/enrollment/view/program/${programId}`, MICROSERVICES.ENROLLMENTMANAGER), { params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getSystems(accountId, programId, page_no, page_size, filter_status) {
    const params = { page_no, page_size, ...(filter_status ? { filter_status: filter_status } : []) }
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/application/view/program/${programId}`, MICROSERVICES.ENROLLMENTMANAGER), { params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async acknowledgeEnrollment(accountId, programId, enrollmentId, status) {
    try {
      const response = await service.put(Urls.getApiUrl(`admin/${accountId}/enrollment/${enrollmentId}/application/status`, MICROSERVICES.ENROLLMENTMANAGER),
        {
          'status': status,
          ...(status === 'Application_Approved' ? { 'enrollment_date': moment().utc().format('YYYY/MM/DD HH:mm:ss') } : {})
        }
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllProgramsDetails(account_id, page_no, page_size) {
    const params = { page_no, page_size }
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${account_id}/programs/program_aggregation`, MICROSERVICES.PROGRAMMANAGER), { params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async addNewSystem(values, currentUser, method, programId, applicationId) {
    let formData = new FormData()
    const payload = {
      homeowner_info: {
        first_name: values.customerFirstName,
        last_name: values.customerLastName,
        address1: values.address1,
        ...(values.address2 ? { address2: values.address2 } : {}),
        city: values.city,
        state: values.state,
        zip: values.zip,
        email_address: currentUser.id,
        electric_account_number: values.ean,
        premise_id: values.premiseId,
      },
      payment_method: values.paymentOptionType,
      program_id: programId,
      source_portal: 'GSP',
      site_id: values.siteId,
    }
    const json = JSON.stringify(payload)
    const blob = new Blob([json], {
      type: 'application/json',
    })
    formData.append('application_form', blob)
    formData.append('tandc_form', new Blob([], {
      type: 'multipart/form-data',
    }))
    formData.append('enrollment_form', values.file ? values.file : new Blob([], {
      type: 'multipart/form-data',
    }))
    formData.append('signed_form1', new Blob([], {
      type: 'multipart/form-data',
    }))
    formData.append('signed_form2', new Blob([], {
      type: 'multipart/form-data',
    }))
    formData.append('user_email_form', new Blob([currentUser.id], {
      type: 'multipart/form-data',
    }))
    try {
      const response = await service[method](Urls.getApiUrl(`admin/${currentUser.account_id}/application/${method === 'put' ? applicationId + '/update' : 'add'}`, MICROSERVICES.ENROLLMENTMANAGER), formData)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getApplicationById(account_id, programId, applicationId) {
    const params = { programId }
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${account_id}/application/${applicationId}`, MICROSERVICES.ENROLLMENTMANAGER), { params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async submitAutoEnrollApplication(accountId, enrollmentID, programId, currentUserId) {
    let formData = new FormData()
    const payload = {
      site_id: enrollmentID,
      program_id: programId,
    }
    const json = JSON.stringify(payload)
    const blob = new Blob([json], {
      type: 'application/json',
    })
    formData.append('application_form', blob)
    formData.append('user_email_form', new Blob([currentUserId], {
      type: 'multipart/form-data',
    })
    )
    try {
      const response = await service.post(Urls.getApiUrl(`admin/${accountId}/application/add`, MICROSERVICES.ENROLLMENTMANAGER), formData)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async postProgramDetailsRequest(programId, programDetails, accountId) {
    var formData = new FormData()
    formData.append('programDetails', programDetails)
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
    try {
      const response = await service.post(Urls.getApiUrl(`admin/${accountId}/programs/${programId}/program-details`, MICROSERVICES.PROGRAMMANAGER), formData, config)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async postProgramEnrollmentConfigRequest(programId, enrollmentConfiguration, accountId) {
    var formData = new FormData()
    formData.append('configuration', enrollmentConfiguration)
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
    try {
      const response = await service.post(Urls.getApiUrl(`admin/${accountId}/programs/${programId}/programenrollmentconfig`, MICROSERVICES.PROGRAMMANAGER), formData, config)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async downloadProgramDetailTemplate(accountId) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/programs/program-details/template`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async downloadApplicationCSVTemplate(accountId) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/programs/programenrollmentconfig/template`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async downloadWidgetsCSVTemplate(accountId) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/widget/template`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async downloadRecentlyUploadedProgramDetailsCSV(accountId, programId) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/programs/${programId}/program-details/download`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async downloadRecentlyUploadedApplicationsCSV(accountId, programId) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/programs/${programId}/programenrollmentconfig/download`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async downloadRecenltyUploadedWidgetsCSV(accountId, programId) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/${programId}/incentive-widget`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
  async uploadWidgetsFile(accountId, programId, widgetsFile) {
    var formData = new FormData()
    formData.append('incentiveWidget', widgetsFile)
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
    try {
      const response = await service.post(Urls.getApiUrl(`admin/${accountId}/${programId}/incentive-widgets`, MICROSERVICES.PROGRAMMANAGER), formData, config)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getCsipConfigurationDetails(accountId) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/csip/masterConfig`,MICROSERVICES.CSIP))
      const { data } = response
      return data.data;
    } catch (e) {
      throw e
    }
  }

  async createorUpdateCsipUtility(accountId, profile, payload) {
    try {
      const response = await service.put(Urls.getApiUrl(`admin/${accountId}/csip/utilityConfig/${profile}`,MICROSERVICES.CSIP), payload)
      const { data } = response
      return data.data;
    } catch (e) {
      throw e
    }
  }

  async getCsipUtilityByProfile(accountId, profile) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/csip/utilityConfig/${profile}`,MICROSERVICES.CSIP))
      const { data } = response
      return data.data;
    } catch (e) {
      throw e
    }
  }

  async uploadCertificate(accountId, profile, file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const config = {
        headers: { 'Content-Type': 'multipart/form-data' },
      };
      const response = await service.post(
        Urls.getApiUrl(`admin/${accountId}/csip/certificate/generateP12/${profile}`, MICROSERVICES.CSIP),
        formData,
        config
      );
      const { data } = response;
      return data.data;
    } catch (e) {
      throw e;
    }
  }

  async getRegisteredSites(accountId, profile, gsProgramId, pageNo, pageSize) {
    try {
      let url = Urls.getApiUrl(
        `admin/${accountId}/edev/siteList`,
        MICROSERVICES.CSIP
      )
      url = `${url}?profile=${profile}&status=REGISTERED&gsProgramId=${gsProgramId}&page_no=${pageNo}&page_size=${pageSize}`
      const response = await service.get(url)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async unregisterSite(accountId, siteId) {
    try {
      const url = Urls.getApiUrl(
        `admin/${accountId}/edev/site/${siteId}`,
        MICROSERVICES.CSIP
      )
      const response = await service.delete(url)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async updateSiteNmi(accountId, siteId, nmi) {
    try {
      let url = Urls.getApiUrl(
        `admin/${accountId}/edev/site/${siteId}/cp`,
        MICROSERVICES.CSIP
      )
      url = `${url}?nmi=${nmi}`
      const response = await service.put(url)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async addNewSite(accountId, site_id, profile, programId) {
    try {
      let url = Urls.getApiUrl(
        `admin/${accountId}/edev/site/${site_id}`,
        MICROSERVICES.CSIP
      )
      url = `${url}?profile=${profile}&gsProgramId=${programId}`
      const response = await service.post(url)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const programService = new ProgramService()
